import {
  Box,
  Checkbox,
  VStack,
  Text,
  Button,
  HStack,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverCloseButton,
  PopoverArrow,
  PopoverBody,
  Wrap,
} from "@chakra-ui/react";
import { FaFilter } from "react-icons/fa";

export default function Filters({
  filters,
  setFilters,
  fetchOrders,
  resetPage,
}) {
  /* ----------------------- STATUS FILTER ----------------------- */
  const handleStatusChange = (status) => {
    setFilters((prev) => {
      const current = prev.status || [];
      const updated = current.includes(status)
        ? current.filter((s) => s !== status)
        : [...current, status];
      return { ...prev, status: updated };
    });
  };

  /* ------------------- PAYMENT STATUS FILTER ------------------- */
  const handlePaymentChange = (payment) => {
    setFilters((prev) => ({
      ...prev,
      paymentStatus: prev.paymentStatus === payment ? "" : payment,
    }));
  };

  /* ---------------- RECEPTIONIST STATUS FILTER ---------------- */
  const handleReceptionistStatusChange = (rs) => {
    setFilters((prev) => ({
      ...prev,
      receptionistStatus:
        prev.receptionistStatus === rs ? "" : rs,
    }));
  };

  /* -------------------- APPLY FILTERS -------------------------- */
  const handleApply = () => {
    resetPage?.(); // Reset to page 1
    fetchOrders();
  };

  const handleClear = () => {
    setFilters({
      status: [],
      paymentStatus: "",
      receptionistStatus: "",
    });
    resetPage?.();
    fetchOrders();
  };

  return (
    <Popover placement="bottom-end">
      <PopoverTrigger>
        <Button
          size="sm"
          leftIcon={<FaFilter />}
          variant="outline"
          colorScheme="gray"
        >
          Filters
        </Button>
      </PopoverTrigger>

      <PopoverContent p={4} maxW="320px" borderRadius="md" shadow="lg">
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverHeader fontWeight="bold" fontSize="md" pb={2}>
          Filter Options
        </PopoverHeader>

        <PopoverBody>
          <VStack align="start" spacing={5}>
            {/* 🔹 Order Status */}
            <Box w="full">
              <Text fontSize="sm" fontWeight="semibold" mb={2}>
                Order Status
              </Text>
              <Wrap spacing={3}>
                {["delivered", "pending", "in-progress", "cancel"].map(
                  (status) => (
                    <Checkbox
                      size="sm"
                      key={status}
                      isChecked={filters.status?.includes(status)}
                      onChange={() => handleStatusChange(status)}
                    >
                      {status}
                    </Checkbox>
                  )
                )}
              </Wrap>
            </Box>

            {/* 🔹 Payment Status */}
            <Box w="full">
              <Text fontSize="sm" fontWeight="semibold" mb={2}>
                Payment Status
              </Text>
              <Wrap spacing={3}>
                {["paid", "pending"].map((payment) => (
                  <Checkbox
                    size="sm"
                    key={payment}
                    isChecked={filters.paymentStatus === payment}
                    onChange={() => handlePaymentChange(payment)}
                  >
                    {payment}
                  </Checkbox>
                ))}
              </Wrap>
            </Box>

            {/* 🔹 Receptionist Status */}
            <Box w="full">
              <Text fontSize="sm" fontWeight="semibold" mb={2}>
                Receptionist Status
              </Text>
              <Wrap spacing={3}>
                {["done", "in-progress"].map((rs) => (
                  <Checkbox
                    size="sm"
                    key={rs}
                    isChecked={filters.receptionistStatus === rs}
                    onChange={() => handleReceptionistStatusChange(rs)}
                  >
                    {rs}
                  </Checkbox>
                ))}
              </Wrap>
            </Box>

            {/* 🔹 Actions */}
            <HStack pt={2} w="full" justify="space-between">
              <Button
                variant="ghost"
                size="sm"
                colorScheme="gray"
                onClick={handleClear}
              >
                Clear
              </Button>
              <Button colorScheme="blue" size="sm" onClick={handleApply}>
                Apply
              </Button>
            </HStack>
          </VStack>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
}
